var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_564)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_564",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.772461 0.186584H64.7725V64.1866H0.772461V0.186584Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15634 35.7969L2.02246 32.2555L8.49934 15.0888L14.5336 16.6804L25.8388 13.3173C27.387 12.8566 28.6671 12.7248 30.1506 13.5813L32.6237 15.0091M49.1862 30.8841C51.7443 32.431 53.7613 33.6461 54.2872 33.9498C55.7558 34.7976 56.2635 36.6928 55.4157 38.1614C54.5678 39.6299 52.6727 40.1378 51.2041 39.2899L48.5232 37.742C49.9908 38.5901 50.4981 40.4848 49.6505 41.9531C48.8026 43.4216 46.9075 43.9295 45.439 43.0815L43.6751 42.0633C45.1431 42.9114 45.6503 44.806 44.8027 46.2744C43.955 47.7429 42.0597 48.2508 40.5911 47.4029L37.5867 45.6684C39.0547 46.5164 39.5623 48.4113 38.7146 49.8796C37.8667 51.3481 35.9716 51.856 34.5028 51.0081L30.0653 48.4461M55.7785 35.401L63.5225 32.4994L57.5091 15.3666L50.9417 16.6804L39.6363 13.3173C38.0882 12.8566 36.8082 12.7248 35.3247 13.5813L26.4835 18.6856C24.9998 19.5423 24.4871 21.4571 25.3435 22.9406C26.2 24.4241 28.0623 24.8394 29.5983 24.0808C30.9535 23.4114 33.0553 22.4696 34.4702 21.9765C34.4828 21.9765 36.6561 23.2928 39.5627 25.0544",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0654 37.0775C21.9113 37.3445 21.7571 37.6115 21.6029 37.8785C22.4508 36.41 24.3459 35.9021 25.8146 36.75C27.2832 37.5979 27.7911 39.4931 26.9431 40.9616C26.7302 41.3304 26.5173 41.6991 26.3044 42.0679C27.1523 40.5992 29.0474 40.0915 30.5161 40.9394C31.9847 41.7872 32.4924 43.6824 31.6447 45.151L29.8993 48.174C29.0514 49.6426 27.1563 50.1504 25.6877 49.3025C24.2191 48.4546 23.7112 46.5594 24.5591 45.0909C24.3462 45.4596 24.1333 45.8284 23.9204 46.1971C23.0727 47.6656 21.1774 48.1734 19.7088 47.3255C18.2403 46.4776 17.7326 44.5826 18.5802 43.1141C18.4261 43.381 18.2719 43.648 18.1178 43.9149C17.2699 45.3835 15.3748 45.8912 13.9063 45.0435L13.9062 45.0434C12.4377 44.1955 11.9298 42.3004 12.7777 40.8317C12.9956 40.4542 13.2136 40.0769 13.4316 39.6994C12.5824 41.1646 10.6896 41.6707 9.2223 40.8236C7.7538 39.9757 7.2458 38.0805 8.09393 36.612C8.67555 35.6044 9.25731 34.5966 9.83906 33.589C10.6871 32.1204 12.5822 31.6125 14.0508 32.4605C15.5183 33.3077 16.0263 35.2007 15.1812 36.6689C15.6958 35.7774 16.2106 34.8859 16.7252 33.9942C17.5732 32.5257 19.4683 32.018 20.9368 32.8659L20.9369 32.866C22.4056 33.7137 22.9133 35.6089 22.0654 37.0775Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1813 36.669L13.4316 39.6993",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6031 37.8786L18.5803 43.1142",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3045 42.0679L24.5591 45.0909",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5232 37.7421L38.5754 31.9988",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6751 42.0634L34.9421 37.0214",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5868 45.6684L31.8044 42.3299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.373 27.9707H44.3739",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.772461 0.186523)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.90f5a7ac2a4a4d013877a9c2ed1ab9df.svg";
export { ForwardRef as ReactComponent };